export const mapLayerGeofenceFill = {
    id: 'geofence-fill',
    type: 'fill',
    source: 'geofence',
    paint: {
        'fill-color': ['coalesce', ['get', 'fill'], 'black'],
        'fill-opacity': ['coalesce', ['get', 'fill-opacity'], 0.3],
    },
    filter: ['==', ['geometry-type'], 'Polygon'],
};

export const mapLayerGeofenceFillOutline = {
    id: 'geofence-fill-outline',
    type: 'line',
    source: 'geofence',
    paint: {
        'line-color': ['coalesce', ['get', 'stroke'], 'black'],
        'line-width': ['coalesce', ['get', 'stroke-width'], 1],
        'line-opacity': ['coalesce', ['get', 'stroke-opacity'], 1],
    },
    filter: ['==', ['geometry-type'], 'Polygon'],
};

export const mapLayerGeofenceOutline = {
    id: 'geofence-line',
    type: 'line',
    source: 'geofence',
    paint: {
        'line-color': ['coalesce', ['get', 'stroke'], 'black'],
        'line-width': ['coalesce', ['get', 'stroke-width'], 1],
        'line-opacity': ['coalesce', ['get', 'stroke-opacity'], 1],
    },
    filter: ['==', ['geometry-type'], 'LineString'],
};

export const mapLayerIndividualInstallation = {
    id: 'installation',
    type: 'symbol',
    source: 'installation',
    layout: {
        'icon-image': [
            // Use case expression with 3 steps to determine the marker type
            // * If installation has an alarm, show error marker
            // * If installation has a warning for the service/tank stats, show warning marker
            // * Show default marker otherwise
            'case',
            ['==', ['get', 'status'], 'alarm'],
            'marker-individual-error',
            ['==', ['get', 'status'], 'warning'],
            'marker-individual-warning',
            'marker-individual-ok',
        ],
        'icon-size': 1,
        'icon-anchor': 'bottom',
        'icon-allow-overlap': true,
        'symbol-sort-key': 10000,
    },
};

/**
 *  Styles used for Mapbox GL Draw layers.
 */
export const drawStyles = [
    {
        id: 'gl-draw-polygon-fill-inactive',
        type: 'fill',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['!=', 'mode', 'static'],
        ],
        paint: {
            'fill-color': '#000',
            'fill-outline-color': '#000',
            'fill-opacity': 0.2,
        },
    },
    {
        id: 'gl-draw-polygon-fill-active',
        type: 'fill',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
        paint: {
            'fill-color': '#4790d0',
            'fill-outline-color': '#4790d0',
            'fill-opacity': 0.1,
        },
    },
    {
        id: 'gl-draw-polygon-midpoint',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
        paint: {
            'circle-radius': 3,
            'circle-color': '#4790d0',
        },
    },
    {
        id: 'gl-draw-polygon-stroke-inactive',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Polygon'],
            ['!=', 'mode', 'static'],
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#000',
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-polygon-stroke-active',
        type: 'line',
        filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#4790d0',
            'line-dasharray': [0.2, 2],
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-line-inactive',
        type: 'line',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'LineString'],
            ['!=', 'mode', 'static'],
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#000',
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-line-active',
        type: 'line',
        filter: ['all', ['==', '$type', 'LineString'], ['==', 'active', 'true']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#4790d0',
            'line-dasharray': [0.2, 2],
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-polygon-and-line-vertex-stroke-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['!=', 'mode', 'static'],
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': '#fff',
        },
    },
    {
        id: 'gl-draw-polygon-and-line-vertex-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['!=', 'mode', 'static'],
        ],
        paint: {
            'circle-radius': 3,
            'circle-color': '#4790d0',
        },
    },
    {
        id: 'gl-draw-point-point-stroke-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['!=', 'mode', 'static'],
        ],
        paint: {
            'circle-radius': 5,
            'circle-opacity': 1,
            'circle-color': '#fff',
        },
    },
    {
        id: 'gl-draw-point-inactive',
        type: 'circle',
        filter: [
            'all',
            ['==', 'active', 'false'],
            ['==', '$type', 'Point'],
            ['==', 'meta', 'feature'],
            ['!=', 'mode', 'static'],
        ],
        paint: {
            'circle-radius': 3,
            'circle-color': '#000',
        },
    },
    {
        id: 'gl-draw-point-stroke-active',
        type: 'circle',
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['==', 'active', 'true'],
            ['!=', 'meta', 'midpoint'],
        ],
        paint: {
            'circle-radius': 7,
            'circle-color': '#fff',
        },
    },
    {
        id: 'gl-draw-point-active',
        type: 'circle',
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['!=', 'meta', 'midpoint'],
            ['==', 'active', 'true'],
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': '#4790d0',
        },
    },
    {
        id: 'gl-draw-polygon-fill-static',
        type: 'fill',
        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
        paint: {
            'fill-color': '#404040',
            'fill-outline-color': '#404040',
            'fill-opacity': 0.1,
        },
    },
    {
        id: 'gl-draw-polygon-stroke-static',
        type: 'line',
        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#404040',
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-line-static',
        type: 'line',
        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'LineString']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#404040',
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-point-static',
        type: 'circle',
        filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],
        paint: {
            'circle-radius': 5,
            'circle-color': '#404040',
        },
    },
];
